<template>
  <el-dialog
    :visible.sync="dialogVisible"
    title="还款流程更新"
    width="370px"
    @close="handleClose"
    append-to-body
  >
    <!-- 切换按钮 -->
    <div class="switch-buttons">
      <el-button
        :type="activeTab === 'normal' ? 'success' : 'default'"
        @click="activeTab = 'normal'"
      >
        正常还款
      </el-button>
      <el-button
        :type="activeTab === 'abnormal' ? 'danger' : 'default'"
        @click="activeTab = 'abnormal'"
      >
        还款异常
      </el-button>
    </div>

    <!-- 表单内容 -->
    <el-form :model="formData" ref="formRef" label-width="105px" :rules="rules">

      <el-form-item label="通过额度(元)">
        <el-input v-model="formData.approvedAmount" disabled  />
      </el-form-item>

      <el-form-item label="贷款期限(月)">
        <el-input v-model="formData.loanTerm" disabled />
      </el-form-item>

      <el-form-item label="剩余本金(元)" prop="remainingPrincipal">
        <el-input v-model="formData.remainingPrincipal" placeholder="请输入剩余本金" />
      </el-form-item>

      <!-- 异常情况说明 - 只在还款异常标签页显示 -->
      <el-form-item v-show="activeTab === 'abnormal'" label="异常情况说明" prop="abnormalDescription">
        <el-input
          v-model="formData.abnormalDescription"
          type="textarea"
          :rows="4"
          placeholder="请输入异常情况说明"
        />
      </el-form-item>
    </el-form>

    <div slot="footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleSubmit">提交审核</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { operateDetails,repaymentProgressUpdate } from '@/api/RuralFinance' 

export default {
  name: 'RepaymentManagementDialog',
  props: {
    applyId: {
      type: Number,
      default: 0
    }
  },
  data() {
    // 表单验证规则
    const validateRemainingPrincipal = (rule, value, callback) => {
      if (!value&&value!==0) {
        callback(new Error('请输入剩余本金'))
      } else if (!/^\d+(\.\d{1,2})?$/.test(value)) {
        callback(new Error('请输入有效的金额，最多保留两位小数'))
      } else {
        callback()
      }
    }

    const validateAbnormalDescription = (rule, value, callback) => {
      if (this.activeTab === 'abnormal' && !value) {
        callback(new Error('请输入异常情况说明'))
      } else {
        callback()
      }
    }

    return {
      activeTab: 'normal', // 'normal' 或 'abnormal'
      dialogVisible: false,
      formData: {
        approvedAmount: '',
        loanTerm: '',
        remainingPrincipal: '',
        abnormalDescription: ''
      },
      rules: {
        remainingPrincipal: [{ validator: validateRemainingPrincipal, trigger: 'blur' }],
        abnormalDescription: [{ validator: validateAbnormalDescription, trigger: 'blur' }]
      }
    }
  },
  methods: {

    async init() {
      try {
        let res = await operateDetails({ applyId: this.applyId });
        console.log(res,'这是详情数据')
        if (res.code == 0) {
          this.formData.approvedAmount=res.data.approveMoney||0
          this.formData.loanTerm=res.data.loanTerm
          this.formData.remainingPrincipal=res.data.remainingAmount
        }

        this.activeTab = 'normal'
      } catch (error) {
        this.$message.error('加载数据失败，请稍后重试')
        console.error('加载还款数据失败:', error)
      }
    },

    /**
     * 打开对话框并加载数据
     */
    handleOpen() {
      this.dialogVisible = true
      this.init()
    },

    /**
     * 关闭对话框
     */
    handleClose() {
      this.dialogVisible = false
      if (this.$refs.formRef) {
        this.$refs.formRef.resetFields()
      }
      this.activeTab = 'normal'
    },

    /**
     * 提交表单
     */
    handleSubmit() {
      this.$refs.formRef.validate(async valid => {
        if (valid) {
          try {
            const dto = {
              applyId: this.applyId,
              applyStatus: this.activeTab === 'normal' ? 0 : 1,
              repaymentAmount: this.formData.remainingPrincipal,
              exceptionDesc: this.activeTab === 'abnormal' ? this.formData.abnormalDescription : '',
            }
            console.log('提交dto:', dto)

            // 模拟提交过程
            let res = await repaymentProgressUpdate(dto)
            if (res.code == 0) {
              this.$message.success('提交成功')
              this.dialogVisible = false
            }else{
              this.$message.error(res.msg)
            }
          } catch (error) {
            this.$message.error('提交失败')
            console.error('提交还款数据失败:', error)
          }
        }
      })
    }
  }
}
</script>

<style scoped>
.switch-buttons {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}
</style>
